import React from "react";

interface IframeworkWinPanel {
    data: {}
}
export const frameworkWinPanel: IframeworkWinPanel = {
    data: {
        "COMPONENTS": [
            {
                "id": "WinPanelMainContainer",
                "name": "WinPanelMainContainer",
                "type": "Container",
                "class": "",
                "x": 0,
                "y": 0,
                "layout": true,
                "filterTypes": [],
                child: [
                       {
                                    "id": "textOfContainer1_1",
                                    "name": "text_bet_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "buttonPanelText_1",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                ]
            },
        ],
    }

};
export const winPanelConfigurationContext = React.createContext(
    {}
);